import { render, staticRenderFns } from "./AddEnvelopeModal.vue?vue&type=template&id=0aa4f22e"
import script from "./AddEnvelopeModal.vue?vue&type=script&lang=js"
export * from "./AddEnvelopeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports